export default "__VITE_ASSET__DIuxPcCr__"